export const ROUTE_TEAM_MANAGEMENT_INITIATIVE_DETAILS =
  "teamManagement.initiative.details";
